
export const getObjectsFromURL = (): Object => {
    let params: any = {};
    // href is always lower case?
    if (window.location.href.indexOf('?') !== -1) {
        const search = decodeURIComponent(window.location.href.slice(window.location.href.indexOf('?') + 1));
        let definitions = search.split('&');
        definitions.forEach(function (val, key) {
            let parts = val.split('=', 2);
            params[parts[0]] = parts[1];
        });
    }
    return params;
};

export const getTelematicProviderFromURL = (): string | undefined => {
    const urlParameters: any = getObjectsFromURL();
    if (urlParameters.hasOwnProperty('telematicprovider')) {
        return urlParameters.telematicprovider;
    }
    return undefined;
}
